import React,{useEffect} from 'react'
import 'react-confirm-alert/src/react-confirm-alert.css'
import { useDispatch } from 'react-redux'
import { Grid } from 'semantic-ui-react'
import { addItemsTabWarnings,deleteItemsTabWarnings } from '../../../commonActions/serverErrorAction'
import InputField from '../../../commonComponents/formComponents/inputField'
import { saveLineItemFeild, updateLineItemFeild } from '../../actions'
import { getValidationError as ValidationError } from '../../Helper';
import { CONVERTED_VALUE,CUSTOMS_VALUE,STAT_VALUE,NET_MASS,QUOTA,GROSS_WEIGHT} from '../../Helper/formLabel';
import { useCurrentShipmentType } from '../../../hooks/useCurrentShipmentType';


function MerchForm5(props) {
  const {
    lineItemIndex,
    convertedUnitValue,
    netMass,
    grossMass,
    customValue,
    statValue,
    quotaNumber,
    isFormDisabled,
    invoiceIndex,
    invoiceId,
    isImportShipment,
    translate,
    merchandiseId,
  } = props
  const dispatch = useDispatch()
  const { customJobState } = useCurrentShipmentType()
  const pdiValidationCheck = customJobState?.includes("PDI");



  const getValidationError=(field, value, Level, onlyMandatoryCheck)=>ValidationError(field, value, Level, onlyMandatoryCheck,'',translate,pdiValidationCheck)


  const addErrors = (level, value, fieldName) => dispatch(addItemsTabWarnings(level, value, fieldName))
 
  const deleteErrors = (level, value, fieldName) => dispatch(deleteItemsTabWarnings(level, value, fieldName))
const setValidationError=(field,value,level='itemsTab')=>{
  let err = getValidationError(field, value,level)
    err.length 
      ? addErrors(
        level,
          `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
          `${field}-${merchandiseId}`
        )
      : deleteErrors(level, '', `${field}-${merchandiseId}`)
}
  useEffect(()=>{
    
    setValidationError('convertedUnitValue', convertedUnitValue)

      if(customValue){
        setValidationError('customValue', customValue)
      }
       
    if(!isImportShipment){
      setValidationError('statValue', statValue)

    }

  },[convertedUnitValue,statValue,customValue])
  
  return (
    <Grid.Row>
      <Grid.Column width='3' className='divFormFeild b-rw-0    '>
        <InputField
          isLabel={false}
          id={`convertedUnitValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate(CONVERTED_VALUE, { ns: ['default', 'lineItem'] })}
          boxNumber='35'
          value={convertedUnitValue}
          errors={getValidationError('convertedUnitValue', convertedUnitValue, 'itemsTab')}
          string={'€'}
          addThousandsSeperator={true}
          className={'field-bg'}
          clearInput={false}
          disabled={true}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { convertedUnitValue: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'convertedUnitValue', invoiceId))
            dispatch(saveLineItemFeild(merchandiseId, 'countryOfOrigin', invoiceId))
          }}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild  b-rw-0 '>
        <InputField
          isLabel={false}
          id={`customValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate(CUSTOMS_VALUE, { ns: ['default', 'lineItem'] })}
          mandatory={false}
          value={customValue}
          errors={getValidationError('customValue', customValue, 'itemsTab')}
          string='€'
          addThousandsSeperator={true}
          className='field-bg'
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { customValue: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'customValue', invoiceId))
            let err = getValidationError('customValue', customValue, 'itemsTab')
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `customValue-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `customValue-${merchandiseId}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild  b-rw-0 '>
        <InputField
          isLabel={false}
          id={`statValue-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate(STAT_VALUE, { ns: ['default', 'lineItem'] })}
          boxNumber='46'
          mandatory={false}
          value={statValue}
          errors={getValidationError('statValue', statValue, 'itemsTab')}
          string={'€'}
          addThousandsSeperator={true}
          className={'field-bg'}
          clearInput={false}
          disabled={isFormDisabled}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { statValue: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'statValue', invoiceId))
            let err = getValidationError('statValue', statValue, 'itemsTab')
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `statValue-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `statValue-${merchandiseId}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='3' className='divFormFeild  kg b-rw-0 '>
        <InputField
          isLabel={false}
          id={`grossWeight-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate(GROSS_WEIGHT, { ns: ['default', 'lineItem'] })}
          boxNumber='35'
          disabled={isFormDisabled}
          value={grossMass}
          errors={getValidationError('grossMass', grossMass, 'itemsTab')}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { grossMass: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'grossMass', invoiceId))
            let err = getValidationError('grossMass', grossMass, 'itemsTab')
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `grossMass-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `grossMass-${merchandiseId}`)
          }}
        />
      </Grid.Column>

      <Grid.Column width='2' className='divFormFeild   kg b-rw-0 '>
        <InputField
          isLabel={false}
          id={`netMass-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate(NET_MASS, { ns: ['default', 'lineItem'] })}
          boxNumber='38'
          disabled={isFormDisabled}
          value={netMass}
          errors={getValidationError('netMass', netMass, 'itemsTab')}
          className={'field-bg'}
          clearInput={false}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { netMass: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'netMass', invoiceId))
            let err = getValidationError('netMass', netMass, 'itemsTab')
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `netMass-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `netMass-${merchandiseId}`)
          }}
        />
      </Grid.Column>
      <Grid.Column width='2' className='divFormFeild  '>
        <InputField
          isLabel={false}
          id={`quotaNumber-${invoiceId}-${merchandiseId}`}
          type='number'
          label={translate(QUOTA, { ns: ['default', 'lineItem'] })}
          boxNumber='39'
          disabled={isFormDisabled}
          value={quotaNumber && quotaNumber != -999 ? quotaNumber : ''}
          errors={getValidationError('quotaNumber', quotaNumber, 'itemsTab')}
          className={'field-bg'}
          addThousandsSeperator={true}
          clearInput={false}
          onChange={(value) => {
            dispatch(updateLineItemFeild(invoiceId, merchandiseId, { quotaNumber: value }))
          }}
          onBlur={(value) => {
            dispatch(saveLineItemFeild(merchandiseId, 'quotaNumber', invoiceId))
            let err = getValidationError('quotaNumber', quotaNumber, 'itemsTab')
            err.length
              ? addErrors(
                  'itemsTab',
                  `invoice - 00${invoiceIndex + 1} :: line ${lineItemIndex + 1}.` + ' :: ' + err[0],
                  `quotaNumber-${merchandiseId}`
                )
              : deleteErrors('itemsTab', '', `quotaNumber-${merchandiseId}`)
          }}
        />
      </Grid.Column>
    </Grid.Row>
  )
}
export default React.memo(MerchForm5)
